module.exports = __webpack_public_path__ + "static/media/trash_can.ffaff79d.svg";